import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchCategory, SIDEBAR } from '~/types/enum';
import {
  TDownloadList,
  TProgressList,
  TResourceState,
} from '~/store/resource/resource.type';
import { resourceEduCode } from '~/api/oneBoxV3/oneBoxV3.type';
import dayjs, { Dayjs } from 'dayjs';
import { getStoredSearchCondition } from '~/utils/helper/localStorage';

const storedSearchCondition = getStoredSearchCondition();
const pageSize =
  storedSearchCondition.resources1 &&
  (storedSearchCondition.resources1 as SIDEBAR) !== SIDEBAR.ebook &&
  (storedSearchCondition.resources1 as SIDEBAR) !== SIDEBAR.tiku
    ? 4
    : 30;

const initialState: TResourceState = {
  searchCondition: {
    categories: SearchCategory.SCHOOL, // '補教', '學校', '學校補教共同'(intersection)
    versions: null,
    // sidebars: SIDEBAR.ebook,
    eduCodes: (storedSearchCondition.eduCodes as resourceEduCode) || null,
    years: storedSearchCondition.years || null,
    grades: storedSearchCondition.grades || null,
    subjects: storedSearchCondition.subjects || null,
    resources1: storedSearchCondition.resources1 || null,
    resources2: null,
    resources3: null,
    fuzzySearch: null,
    fuzzySearchFields: null,
    isLaunch: true,
    dateTo: dayjs().toISOString(),
    dateFrom: dayjs().subtract(30, 'days').toISOString(),
    page: 0,
    pageSize,
    sort: '',
  },
  resources: [],
  downloadList: {},
  progressList: [],
  totalDownloadingList: [],
  baseDownloadPath: '',
  totalResourcesCount: 0,
  resourceBookId: '',
  knowledgeChaptersList: [],
};

export const ResourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    resetSearchCondition: (
      state,
      action: PayloadAction<{
        type: 'admin' | 'client';
        categories: SearchCategory;
      }>,
    ) => {
      const { type, categories } = action.payload;
      state.searchCondition =
        type === 'admin'
          ? {
              ...state.searchCondition,
              categories,
              versions: null,
              years: null,
              eduCodes: null,
              subjects: null,
              grades: null,
              dateTo: dayjs().toISOString(),
              dateFrom: dayjs().subtract(30, 'days').toISOString(),
              isLaunch: false,
              page: 0,
              pageSize: 10,
              sort: '-fileUploadTime',
              fuzzySearch: null,
              fuzzySearchFields: null,
            }
          : initialState.searchCondition;
    },
    setDownloadList: (state, action: PayloadAction<TDownloadList>) => {
      state.downloadList = action.payload;
    },
    setProgressList: (state, action: PayloadAction<TProgressList>) => {
      state.progressList = action.payload;
    },
    setSearchCondition: (
      state,
      action: PayloadAction<{
        [title: string]: string | Dayjs | boolean | number | string[];
      }>,
    ) => {
      state.searchCondition = {
        ...state.searchCondition,
        ...action.payload,
      };
    },
    addTotalDownloadingItem: (state, action: PayloadAction<string[]>) => {
      state.totalDownloadingList = [
        ...state.totalDownloadingList,
        {
          label: state.searchCondition.resources1 as string,
          subLabel: action.payload[0],
          lastLabel: action.payload[1],
        },
      ];
    },
    removeTotalDownloadingItem: (state, action: PayloadAction<string[]>) => {
      state.totalDownloadingList = state.totalDownloadingList.filter(
        ({ label, subLabel, lastLabel }) =>
          !(
            label === (state.searchCondition.resources1 as string) &&
            subLabel === action.payload[0] &&
            lastLabel === action.payload[1]
          ),
      );
    },
  },
});

export const {
  setSearchCondition,
  resetSearchCondition,
  setProgressList,
  setDownloadList,
  addTotalDownloadingItem,
  removeTotalDownloadingItem,
} = ResourceSlice.actions;

export default ResourceSlice.reducer;
